import React, { useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import "bootstrap/dist/css/bootstrap.min.css";
import { LiveSearch } from "../../../../../sharedComponents/LiveSearch";
import { useEffect } from "react";
import { writeFile, utils } from "xlsx";
import Tooltips from "../../../../../client-staff/Components/CommanPages/Tooltips";
import TooltipsNew from "../../../../../client-staff/Components/CommanPages/TooltipsNew";

export const ClientListTable = ({
    arrow,
    filterByStatus,
    shortHandler,
    tableData,
    searchHandler,
    handleDownloadClick,
    setStatusFilter,
    statusFilter,

}) => {

    return (
        <>
            <Row className="row">
                <Col className="col-md-7"
                    style={{ display: 'flex', alignItems: "flex-end", }}>
                    <h4><b>Client List</b></h4>
                </Col>
                {/* <Col></Col> */}
                <Col className="col-md-5">
                    <LiveSearch
                        Placeholder={
                            "Search by Name, Status, gender, Date"
                        }
                        onChange={searchHandler}
                        className={"w-100 instructorSearch"}
                    />
                </Col>
            </Row>
            <Row>
                <Col>
                    <div className="downloadPDf">
                        <button
                            className="export_csv"
                            onClick={() => handleDownloadClick(tableData)}>
                            Export (CSV)
                        </button>
                    </div>
                </Col>
            </Row>
            <Row >
                <Col>
                    <table class="table table-bordered">
                        <thead>
                            <tr>
                                <th scope="col"
                                    // style={{
                                    //     display: "flex",
                                    //     justifyContent: " space-between"
                                    // }}
                                    style={{
                                        position: "relative",
                                        // textAlign: "left",
                                        // paddingRight: "30px",
                                        verticalAlign: 'top'
                                    }}
                                    onClick={() => shortHandler(tableData)}>
                                    Name{
                                        arrow ? <i class='fas fa-arrow-circle-up'
                                            style={{
                                                fontSize: "24px",
                                                position: "absolute",
                                                // right: "8px",
                                                top: "35%",
                                                paddingLeft: '10%',
                                                transform: "translateY(-50%)",
                                            }}
                                        //  style={{ fontSize: "24px" }}
                                        >
                                        </i> : <i class='fas fa-arrow-circle-down'
                                            // style={{ fontSize: "24px" }}
                                            style={{
                                                fontSize: "24px",
                                                position: "absolute",
                                                // right: "8px",

                                                // left: '10%',
                                                top: "35%",
                                                paddingLeft: '10%',
                                                transform: "translateY(-50%)",
                                            }}
                                        ></i>
                                    }
                                </th>
                                <th scope="col" style={{ verticalAlign: 'top' }}>Date of Birth</th>
                                <th scope="col" style={{ verticalAlign: 'top' }}>Email</th>
                                <th scope="col" style={{ verticalAlign: 'top' }}>Mobile</th>
                                <th scope="col" style={{ verticalAlign: 'top' }}>Age</th>
                                <th scope="col" style={{ verticalAlign: 'top' }}>Gender</th>
                                <th scope="col" style={{ verticalAlign: 'top' }}>Start Date</th>
                                {/* <th scope="col">Status</th> */}

                                <th scope="col">
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <span>Status    <TooltipsNew info={'Inactive Status \n A client is marked as inactive if they do not have an active pass, a future appointment, or are registered for a future workshop.'} />
                                        </span>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between gap-2">
                                        <select
                                            className="form-select form-select-sm"
                                            style={{ width: "120px", maxHeight: '35px' }}
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                            onClick={(e) => filterByStatus(e.target.value)}
                                        >
                                            <option value="All">All</option>
                                            <option value="Active">Active</option>
                                            <option value="Deactive">Inactive</option>
                                        </select>
                                    </div>


                                </th>

                            </tr>
                        </thead>
                        <tbody>
                            {tableData && (tableData || []).map((e) => (
                                <tr key={e.id}>
                                    <td>{e.Name}</td>
                                    <td>{e.dob}</td>
                                    <td>{e.Email}</td>
                                    <td>{e.mobile}</td>
                                    <td>{e.Age}</td>
                                    <td>{e.Gender}</td>
                                    <td>{e.Start_Date}</td>
                                    <td>{e.Status === "Deactive" ? "Inactive" : e.Status} </td>
                                </tr>
                            ))}
                        </tbody>
                        {/* {visibleCount < tableData.length && (
                            <div className="text-center mt-3 mb-3">
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                    style={{
                                        padding: '4px 17px',
                                        fontSize: '1rem',
                                        display: 'flex',
                                        justifyContent: 'right'
                                    }}
                                    onClick={() =>
                                        setVisibleCount((prev) =>
                                            Math.min(prev + 10, tableData.length)
                                        )
                                    }
                                >
                                    Load More
                                </button>
                            </div>
                        )} */}
                    </table>

                </Col>
                {/* <Col> */}
                {/* <BootstrapTable
                        keyField="id"
                        data={tabledata}
                        columns={columns}
                        striped
                        hover
                        wrapperClasses="table-responsive"
                        pagination={paginationFactory()}
                    /> */}
                {/* </Col> */}
                {tableData && tableData.length <= 0 && (
                    <p className="text-center">Please wait, data is loading...</p>
                )}
            </Row >

        </>
    )
}
